import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { DxTooltipModule, DxButtonModule, DxCheckBoxModule, DxDataGridModule, DxSortableModule, DxScrollViewModule, DxTabPanelModule, DxSelectBoxModule, DxHtmlEditorModule } from 'devextreme-angular';
import { DashboardModule } from 'src/app/shared/shared-dashboard/dashboard.module';
import { TitleBreadbreadcrumbModule } from 'src/app/shared/title-breadbreadcrumb/title-breadbreadcrumb.module';


import { MdbGlobalModule } from 'src/app/shared/mdb-global.module';
// import { BlogSalesCompComponent } from '../components/blog-sales-comp/blog-sales-comp.component';
// import { NewComentBlogModalComponent } from '../modals/new-coment-blog-modal/new-coment-blog-modal.component';
// import { NewTaskModalComponent } from '../modals/new-task-modal/new-task-modal.component';
import { NewActivityGenericComponent } from 'src/app/shared/new-activity-generic/new-activity-generic.component';

import { SharedDatagridModule } from 'src/app/shared/shared-datagrid/shared-datagrid.module';

import { DxFormModule, DxToolbarModule, DxNumberBoxModule,DxAccordionModule,DxFileUploaderModule,DxDropDownButtonModule, DxButtonGroupModule, DxAutocompleteModule, DxContextMenuModule, DxDateBoxModule, DxDropDownBoxModule, DxGanttModule, DxPopupModule, DxRadioGroupModule, DxSchedulerModule, DxSliderModule, DxTextBoxModule, DxTreeViewModule, DxTagBoxModule, DxTextAreaModule } from 'devextreme-angular';
// import { EditSalesLeadDinamicoComponent } from './edit-sales-lead-dinamico.component';
// import { EditSalesCompComponent } from '../components/edit-sales-comp/edit-sales-comp.component';
// import { MarketCompaniesThatYouCompeteModule } from '../../market-analysis/market-companies-that-you-compete/market-companies-that-you-compete.module';
// import { NewCustomerModule } from '../../employee-activities/forms/new-customer/new-customer.module';
import { DinamicModalModule } from 'src/app/shared/dinamic-modal/dinamic-modal.module';
import { CreateUpdateActivityDinamicModule } from 'src/app/pages/home/my-activity/create-update-activity-dinamic/create-update-activity-dinamic.module';
// import { NewComentDinamicoModule } from '../modals/new-coment-blog-modal/new-coment-blog-modal.module';
import { NewContactModule } from 'src/app/shared/new-contact/new-contact.module';
import { NewEmployeeModule } from 'src/app/shared/new-employee/new-employee.module';
import { SendEmailModule } from 'src/app/shared/send-email-dinamic/send-email-dinamic.module';
import { activityDinamicComponent } from './activity-dinamic.component';
// import { NewTaskModalComponent } from '../sales-leads/modals/new-task-modal/new-task-modal.component';
import { NewComentBlogModalComponent } from '../sales-leads/modals/new-coment-blog-modal/new-coment-blog-modal.component';
import { MarketCompaniesThatYouCompeteModule } from '../market-analysis/market-companies-that-you-compete/market-companies-that-you-compete.module';
import { NewCustomerModule } from '../employee-activities/forms/new-customer/new-customer.module';
import { NewComentDinamicoModule } from '../sales-leads/modals/new-coment-blog-modal/new-coment-blog-modal.module';

@NgModule({
  declarations: [
    // NewComentBlogModalComponent,
    // NewTaskModalComponent,
    // NewActivityGenericComponent,
    activityDinamicComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    DashboardModule,
    TitleBreadbreadcrumbModule,
    MdbGlobalModule,
    DxDataGridModule,
    DxButtonModule,
    DxCheckBoxModule,
    SharedDatagridModule,
    DxSortableModule,
    DxScrollViewModule,
    DxTabPanelModule,
    DxSelectBoxModule,
    DxFormModule,
    DxToolbarModule,
    DxNumberBoxModule,
    DxAccordionModule,
    DxFileUploaderModule,
    DxDropDownButtonModule,
    DxButtonGroupModule,
    DxAutocompleteModule,
    DxContextMenuModule,
    DxDateBoxModule,
    DxDropDownBoxModule,
    DxGanttModule,
    DxPopupModule,
    DxRadioGroupModule,
    DxSchedulerModule,
    DxSliderModule,
    DxTextBoxModule,
    DxTreeViewModule,
    DxTagBoxModule,
    DxTextAreaModule,
    MarketCompaniesThatYouCompeteModule,
    NewCustomerModule,
    DinamicModalModule,
    DxTooltipModule,
    CreateUpdateActivityDinamicModule,
    NewComentDinamicoModule,
    DxHtmlEditorModule,
    NewContactModule,
    NewEmployeeModule,
    SendEmailModule,
    // CreateUpdateActivityModule
  ],
  exports:[activityDinamicComponent],
  entryComponents: [
    // NewTaskModalComponent,
    // NewActivityGenericComponent,
    // NewComentBlogModalComponent
  ],
})
export class activityDinamicModule { }
